import {
  sortByHotDeal,
  sortByAva,
  sortByHotelName,
  sortByPrice,
  sortByPriceDesc,
  sortByStarRating
} from 'b2b-common/utils/hotel/sorting'

const random = () => {
  return Math.floor((Math.random() * 100000 + 1))
}

export default {
  data () {
    return {
      activeRequests: [],
      selectedResultsPerPage: Number.MAX_SAFE_INTEGER,
      selectedSortMethod: sortByHotDeal,
      resultsPerPage: [
        { text: 'toate rezultatele', value: Number.MAX_SAFE_INTEGER },
        { text: '25 rezultate/pagina', value: 25 },
        { text: '50 rezultate/pagina', value: 50 },
        { text: '100 rezultate/pagina', value: 100 }
      ],
      sortMethods: [
        { text: '--ordoneaza rezultate --', value: null },
        { text: 'Best Deal', value: sortByHotDeal },
        { text: 'Disponibilitate', value: sortByAva },
        { text: 'Pret crescator', value: sortByPrice },
        { text: 'Pret descrescator', value: sortByPriceDesc },
        { text: 'Nume hotel', value: sortByHotelName },
        { text: 'Numar stele', value: sortByStarRating }
      ],
      roomKey: 'room' + random()
    }
  },
  computed: {
    sortDropdownClass () {
      return { 'best-deal': this.selectedSortMethod === sortByHotDeal }
    }
  },
  methods: {
    genRoomKey (index) {
      return this.roomKey + '/' + index
    },
    onSubmit () {
      this.$emit('search', this.selectedParams)
    },
    resetList (toBeReset) {
      const arrayOfLists = Array.isArray(toBeReset) ? toBeReset : [toBeReset]
      arrayOfLists.forEach(el => {
        this[el + 'List'] = []
      })
    },
    onRoomAdd () {
      this.selectedParams.rooms.push({ adults: 2, ages: [] })
      this.roomKey = 'room' + random()
    },
    onRoomDelete (index) {
      this.selectedParams.rooms.splice(index, 1)
      this.roomKey = 'room' + random()
    },
    valueExistsInList (listName, value) {
      const list = this[listName + 'List']
      const index = list.findIndex(el => (el === value) || (el.id && el.id === value))
      return index >= 0
    },
    addRequest (reqType) {
      this.activeRequests.push(reqType)
    },
    removeRequest (reqType) {
      const index = this.activeRequests.indexOf(reqType)
      if (index >= 0) this.activeRequests.splice(index, 1)
    }
  }
}
